import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ApplicationLayout from './applicationLayout';
import PrivateRoute from './PrivateRoute';
import { useAuthStore } from './store/authStore';
import LeaguesPage from './pages/LeaguesPage';
import TournamentsPage from './pages/TournamentsPage';
import TournamentPage from './pages/Tournament/TournamentPage';
import TeamRegistrationPage from './pages/TeamRegistrationPage';
import EditProfilePage from './pages/EditProfilePage';
import SupportPage from './pages/SupportPage';
import EmailResend from './pages/EmailResend';
import ResultSubmissionPage from './pages/League/ResultSubmissionPage';
import PlayersCopyLocalPage from './pages/League/PlayersCopyLocalPage';
import ReportsPage from './pages/association/Reports/ReportsPage';
import ClubsPage from './pages/association/Clubs/ClubsPage';
import TournamentsAdminPage from './pages/association/Tournaments/TournamentsAdminPage';
import TournamentAdminFormPage from './pages/association/Tournaments/TournamentAdminFormPage';
import DtausEinzugPage from './pages/association/DtausDirectDebit';
import DtausDirectDebitDetail from './pages/association/DtausDirectDebit/DetailPage';

// @ts-expect-error TS1343
const IS_SEPA = import.meta.env.VITE_APP_SEPA_ENABLED;

const routesConfigBase = [
  {
    path: '/',
    element: <LoginPage />,
    private: false,
    layout: false,
  },
  {
    path: '/League',
    element: <LeaguesPage />,
    private: true,
    layout: true,
  },
  {
    path: '/support',
    element: <SupportPage />,
    private: true,
    layout: true,
  },
  {
    path: '/team-registration/*',
    element: <TeamRegistrationPage />,
    private: true,
    layout: true,
  },
  {
    path: '/reports',
    element: <ReportsPage />,
    private: true,
    layout: true,
  },
  {
    path: '/clubs',
    element: <ClubsPage />,
    private: true,
    layout: true,
  },
  {
    path: '/association/tournaments',
    element: <TournamentsAdminPage />,
    private: true,
    layout: true,
  },
  {
    path: '/association/tournaments/new',
    element: <TournamentAdminFormPage />,
    private: true,
    layout: true,
  },
  {
    path: '/association/tournaments/:id',
    element: <TournamentAdminFormPage />,
    private: true,
    layout: true,
  },
  {
    path: '/league/result-submission/:leagueId/:classId/:teamId/:registrationId/:day',
    element: <ResultSubmissionPage />,
    private: true,
    layout: true,
  },
  {
    path: '/league/players-copy-Local/:registrationId',
    element: <PlayersCopyLocalPage />,
    private: true,
    layout: true,
  },
  {
    path: '/tournaments',
    element: <TournamentsPage />,
    private: true,
    layout: true,
  },
  {
    path: '/tournaments/:id',
    element: <TournamentPage />,
    private: true,
    layout: true,
  },
  {
    path: '/profile',
    element: <EditProfilePage />,
    private: true,
    layout: true,
  },
  {
    path: '/email-resend',
    element: <EmailResend />,
    private: true,
    layout: true,
  },
];

const routesConfig =
  IS_SEPA === 'active'
    ? [
        ...routesConfigBase,
        {
          path: '/dtaus-direct-debit',
          element: <DtausEinzugPage />,
          private: true,
          layout: true,
        },
        {
          path: '/dtaus-direct-debit/:id',
          element: <DtausDirectDebitDetail />,
          private: true,
          layout: true,
        },
      ]
    : routesConfigBase;

const RouterConfig: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());

  return (
    <Router>
      <Routes>
        {routesConfig.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              route.private ? (
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  {route.layout ? (
                    <ApplicationLayout>{route.element}</ApplicationLayout>
                  ) : (
                    route.element
                  )}
                </PrivateRoute>
              ) : route.layout ? (
                <ApplicationLayout>{route.element}</ApplicationLayout>
              ) : (
                route.element
              )
            }
          />
        ))}
      </Routes>
    </Router>
  );
};

export default RouterConfig;
